module.exports = __webpack_public_path__ + "img/t1-blue.747e7f58.png";